import * as createApiKeys from 'store/actions/apiKeys/createApiKeys';
import * as deleteApiKeys from 'store/actions/apiKeys/deleteApiKeys';
import * as fetchApiKeys from 'store/actions/apiKeys/fetchApiKeys';
import * as updateApiKeys from 'store/actions/apiKeys/updateApiKeys';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import utils from 'helpers/utils';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

// Fetch multiple API keys.
function* fetchApiKeysAsync({ payload }) {
    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/applications`;

        // Fetch the data.
        const response = yield apiClient.read(url, payload);

        // Send the data the success action.
        yield put(fetchApiKeys.fetchApiKeysSuccess(response));
    } catch (error) {
        // Trigger the error action.
        yield put(fetchApiKeys.fetchApiKeysFailure(error));
    }
}

// Fetch singular API key.
function* fetchApiKeyAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/applications/${ id }`;

        // Fetch the data.
        const response = yield apiClient.read(url);

        // Send the data to the success action.
        yield put(fetchApiKeys.fetchApiKeySuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        // Trigger the error action.
        yield put(fetchApiKeys.fetchApiKeyFailure(error, payload));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createApiKeyAsync({ payload }) {
    const {
        callback,
        values,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/applications`;
        // Post the data.
        const response = yield apiClient.create(url, values);

        yield put(createApiKeys.createApiKeySuccess(response));

        yield callback();
    } catch (error) {
        // Trigger the error action.
        yield put(createApiKeys.createApiKeyFailure(error));

        yield callback(error);
    }
}

function* createApiKeySuccessAsync() {
    yield put(showNotification('notifications.api-keys.create.success'));
}

function* updateApiKeyAsync({ payload }) {
    const {
        callback,
        id,
        values,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/applications/${ id }`;

        // Post the data.
        const response = yield apiClient.patch(url, values);

        yield put(updateApiKeys.updateApiKeySuccess(response));

        yield callback();
    } catch (error) {
        // Trigger the error action.
        yield put(updateApiKeys.updateApiKeyFailure(error));

        yield callback(error);
    }
}

function* updateApiKeySuccessAsync() {
    yield put(showNotification('notifications.api-keys.update.success'));
}

function* deleteApiKeyAsync({ payload }) {
    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/applications/${ payload.id }`;

        // Delete the data.
        yield apiClient.delete(url);

        if (payload.callback) {
            yield payload.callback();
        }

        yield put(deleteApiKeys.deleteApiKeySuccess(payload));
    } catch (error) {
        // Trigger the error action.
        yield put(deleteApiKeys.deleteApiKeyFailure(error));
    }
}

function* deleteApiKeySuccessAsync() {
    // Redirect the user to the correct page.
    yield put(showNotification('notifications.api-keys.delete.success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    yield put(showNotification(message, 'warning'));
}

export default function* ApiKeysSagas() {
    yield [
        takeEvery('FETCH_API_KEYS', fetchApiKeysAsync),
        takeEvery('FETCH_API_KEYS_FAILURE', failureMessage),

        takeEvery('FETCH_API_KEY', fetchApiKeyAsync),
        takeEvery('FETCH_API_KEY_FAILURE', failureMessage),

        takeEvery('CREATE_API_KEY', createApiKeyAsync),
        takeEvery('CREATE_API_KEY_SUCCESS', createApiKeySuccessAsync),

        takeEvery('UPDATE_API_KEY', updateApiKeyAsync),
        takeEvery('UPDATE_API_KEY_FAILURE', failureMessage),
        takeEvery('UPDATE_API_KEY_SUCCESS', updateApiKeySuccessAsync),

        takeEvery('DELETE_API_KEY', deleteApiKeyAsync),
        takeEvery('DELETE_API_KEY_FAILURE', failureMessage),
        takeEvery('DELETE_API_KEY_SUCCESS', deleteApiKeySuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/apiKeysSagas.js